if (!customElements.get('pre-product-carousel')) {
    customElements.define(
        'pre-product-carousel',
        class ProductCarousel extends HTMLElement {
            constructor() {
                super();
                this.swiperWrapper = this.querySelector('.swiper-wrapper');
            }

            connectedCallback() {
                this.initializeSwiper();
            }

            initializeSwiper() {
                if (!window.Swiper) {
                    const swiperScript = document.createElement('script');
                    swiperScript.src =
                        'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                    swiperScript.onload = () => this.initSwiperInstance();
                    document.head.appendChild(swiperScript);
                } else {
                    this.initSwiperInstance();
                }
            }

            initSwiperInstance() {
                const pcItems = parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-pc')) || 3;
                const mobileItems = parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-mobile')) || 1.5;

                this.swiperInstance = new Swiper(this, {
                    loop: true,
                    scrollbar: {
                        el: this.querySelector('.swiper-scrollbar'),
                        hide: true,
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    spaceBetween: 24,
                    breakpoints: {
                        320: { slidesPerView: mobileItems },
                        768: { slidesPerView: mobileItems },
                        1024: { slidesPerView: pcItems },
                    },
                });

                this.swiperInstance.update();
                this.swiperInstance.slideToLoop(0, 0);
            }
        },
    );
}
